#import '../../../graphql/fragments/common.gql'

query Me {
  me {
    id
    hasSupplier
    hasProfile
    hasKsbAccount
    email
    role
    isOwner
    supplierCode
    userRegistration {
      status
      questionnaire {
        legalOrigin
        legal {
          name
          nameML {
            langCode
            value
          }
          details {
            tin
            kpp
            ogrn
          }
          address
          addressML {
            langCode
            value
          }
          townName
          isNotTaxPayer
        }
        accommodationObject {
          name
          nameML {
            langCode
            value
          }
          type {
            cid
            name
          }
          addressData {
            townName
            address
            addressML {
              langCode
              value
            }
          }
        }
        contact {
          phone
          email
          webSite
        }
      }
    }
    permissions
    profile {
      lastName
      middleName
      name
      phoneNumber
      userAvatar {
        url
        canNotLoad
      }
    }
  }
}

mutation UpdateUserProfile($middleName: String, $lastName: String!, $name: String!, $phoneNumber: String!) {
  updateUserProfile(
    updateUserProfileInput: {
      userProfile: { lastName: $lastName, middleName: $middleName, name: $name, phoneNumber: $phoneNumber }
    }
  ) {
    user {
      id
    }
    errors {
      ...Error
    }
  }
}

query IsLegalFree($tin: String!) {
  isLegalFree(input: { tin: $tin })
}

mutation JoinToSupplier($inviteCode: String!) {
  joinToSupplier(input: { inviteCode: $inviteCode }) {
    status
    errors {
      ...Error
    }
  }
}

mutation SendSupplierQuestionnaire(
  $legalName: String
  $legalNameML: [LangStringInput!]
  $kpp: String
  $ogrn: String
  $tin: String!
  $legalAddress: String
  $legalAddressML: [LangStringInput!]
  $legalTownName: String
  $objectName: String
  $objectNameML: [LangStringInput!]
  $objectTypeName: String!
  $objectTypeCid: String!
  $objectAddress: String
  $objectAddressML: [LangStringInput!]
  $objectTownName: String
  $phone: String!
  $email: String!
  $webSite: String
  $version: Int!
  $isNew: Boolean!
  $isNotTaxPayer: Boolean!
  $legalOrigin: LegalOrigin!
) {
  sendSupplierQuestionnaire(
    input: {
      legal: {
        name: $legalName
        nameML: $legalNameML
        legalDetails: { kpp: $kpp, tin: $tin, ogrn: $ogrn }
        address: {
          address: $legalAddress
          addressML: $legalAddressML
          townName: $legalTownName
        }
        isNotTaxPayer: $isNotTaxPayer
        legalOrigin: $legalOrigin
      }
      accommodationObject: {
        name: $objectName
        nameML: $objectNameML
        type: { name: $objectTypeName, cid: $objectTypeCid }
        addressData: {
          address: $objectAddress
          addressML: $objectAddressML
          townName: $objectTownName
        }
      }
      contact: { phone: $phone, email: $email, webSite: $webSite }
      version: $version
      isNew: $isNew
    }
  ) {
    SupplierCode
    errors {
      ...Error
    }
  }
}

mutation UpdateSupplierQuestionnaire(
  $legalName: String
  $legalNameML: [LangStringInput!]
  $kpp: String
  $ogrn: String
  $tin: String!
  $legalAddress: String
  $legalAddressML: [LangStringInput!]
  $legalTownName: String
  $objectName: String
  $objectNameML: [LangStringInput!]
  $objectTypeName: String!
  $objectTypeCid: String!
  $objectAddress: String
  $objectAddressML: [LangStringInput!]
  $objectTownName: String
  $phone: String!
  $email: String!
  $webSite: String
  $version: Int!
  $isNew: Boolean!
  $isNotTaxPayer: Boolean!
  $legalOrigin: LegalOrigin!
) {
  updateSupplierQuestionnaire(
    input: {
      legal: {
        name: $legalName
        nameML: $legalNameML
        legalDetails: { kpp: $kpp, tin: $tin, ogrn: $ogrn }
        address: {
          address: $legalAddress
          addressML: $legalAddressML
          townName: $legalTownName
        }
        isNotTaxPayer: $isNotTaxPayer
        legalOrigin: $legalOrigin
      }
      accommodationObject: {
        name: $objectName
        nameML: $objectNameML
        type: { name: $objectTypeName, cid: $objectTypeCid }
        addressData: {
          address: $objectAddress
          addressML: $objectAddressML
          townName: $objectTownName
        }
      }
      contact: { phone: $phone, email: $email, webSite: $webSite }
      version: $version
      isNew: $isNew
    }
  ) {
    status
    errors {
      ...Error
    }
  }
}

mutation CreateSupplier {
  createSupplier {
    SupplierCode
  }
}

mutation RegisterKsbAccount {
  registerKsbAccount {
    status
  }
}
